export const GRUPO_ALTERAR_DETALHES_DA_ESCALA = '1' // 'grupoAlterarDetalhesDaEscala'
export const GRUPO_EDITAR_DETALHES = '2' // 'grupoEditarDetalhes'
export const GRUPO_CONVIDAR_USUARIO = '3' // 'grupoConvidarUsuario'
export const GRUPO_NOVA_ESCALA = '4' // 'grupoNovaEscala'
export const GRUPO_GERAR_FOLHA_DE_PONTO = '5' // 'grupoGerarFolhaDePonto'
export const GRUPO_SIMULAR_FOLHA_DE_PONTO = '6' // 'grupoSimularFolhaDePonto'
export const GRUPO_FOLHA_DE_PAGAMENTO = '7' // 'grupoFolhaDePagamento'
export const GRUPO_VER_TODOS_OS_PLANTOES = '8' // 'grupoVerTodosOsPlantoes'
export const GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES = '9' // 'grupoCompartilharTodosOsPlantoes'
export const GRUPO_CRIAR_ESCALA = '10' // 'grupoCriarEscala'
export const GRUPO_ACOMPANHAR_ESCALA = '11' // 'grupoAcompanharEscala'
export const ESCALA_APAGAR = '12' // 'escalaApagar'
export const ESCALA_RENOVAR_LINK = '13' // 'escalaRenovarLink'
export const ESCALA_COMPARTILHAR = '14' // 'escalaCompartilhar'
export const ESCALA_RETIRAR_USUARIO = '15' // 'escalaRetirarUsuario'
export const ESCALA_ALTERAR_PAPEL = '16' // 'escalaAlterarPapel'
export const ESCALA_VER_PLANTOES_DO_USUARIO = '17' // 'escalaVerPlantoesDoUsuario'
export const DETALHES_PLANTAO_NOVO_PLANTAO = '18' // 'detalhesPlantaoNovoPlantao'
export const DETALHES_PLANTAO_VER = '19' // 'detalhesPlantaoVer'
export const DETALHES_PLANTAO_APAGAR = '20' // 'detalhesPlantaoApagar'
export const DETALHES_PLANTAO_DIVIDIR = '21' // 'detalhesPlantaoDividir'
export const DETALHES_PLANTAO_ALTERAR = '22' // 'detalhesPlantaoAlterar'
export const DETALHES_PLANTAO_PERSONALIZAR_REGISTRO = '23' // 'detalhesPlantaoPersonalizarRegistro'
export const DEFINIR_PARAMETRIZACAO_HORA_DE_TRABALHO = '24' // 'definirParametrizacaoHoraDeTrabalho'
export const EXPORT_OPERATIONAL_REPORT = '25' // 'exportOperationalReport'
export const ESCALA_DISPARAR_PLANTOES = '26' // 'escalaDispararPlantoes'
export const GRUPO_VER_USUARIOS = '27' // 'grupoVerUsuarios'
export const GRUPO_VER_VALORES = '28' // 'grupoVerValores'

export const USER_CAPABILITIES = [
  { label: 'Editar detalhes do grupo', value: GRUPO_EDITAR_DETALHES, group: 'Ações do grupo' },
  { label: 'Convidar usuário', value: GRUPO_CONVIDAR_USUARIO, group: 'Ações do grupo' },
  { label: 'Nova escala', value: GRUPO_NOVA_ESCALA, group: 'Ações do grupo' },
  { label: 'Ver usuários', value: GRUPO_VER_USUARIOS, group: 'Ações do grupo' },
  { label: 'Ver valores', value: GRUPO_VER_VALORES, group: 'Ações do grupo' },
  { label: 'Gerar registro check in/out', value: GRUPO_GERAR_FOLHA_DE_PONTO, group: 'Ações do grupo' },
  { label: 'Simular registro check in/out', value: GRUPO_SIMULAR_FOLHA_DE_PONTO, group: 'Ações do grupo' },
  { label: 'Folha de pagamento', value: GRUPO_FOLHA_DE_PAGAMENTO, group: 'Ações do grupo' },
  { label: 'Ver todos os plantões', value: GRUPO_VER_TODOS_OS_PLANTOES, group: 'Ações do grupo' },
  { label: 'Compartilhar todos os plantões', value: GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, group: 'Ações do grupo' },
  { label: 'Definir parametrização de hora de trabalho', value: DEFINIR_PARAMETRIZACAO_HORA_DE_TRABALHO, group: 'Ações do grupo' },
  { label: 'Gerar relatório operacional', value: EXPORT_OPERATIONAL_REPORT, group: 'Ações do grupo' },
  { label: 'Ver usuários', value: GRUPO_VER_USUARIOS, group: 'Ações do grupo' },
  { label: 'Ver valores', value: GRUPO_VER_VALORES, group: 'Ações do grupo' },
  {label: 'Compartilhar todos os plantões (personalizado)', value: GRUPO_COMPARTILHAR_TODOS_OS_PLANTOES, group: 'Ações do grupo'},

  { label: 'Alterar detalhes da escala', value: GRUPO_ALTERAR_DETALHES_DA_ESCALA, group: 'Ações da escala' },
  { label: 'Criar escala (Antigo Editar escala)', value: GRUPO_CRIAR_ESCALA, group: 'Ações da escala' },
  { label: 'Acompanhar escala (Antigo Ver escala)', value: GRUPO_ACOMPANHAR_ESCALA, group: 'Ações da escala' },
  { label: 'Disparar plantões', value: ESCALA_DISPARAR_PLANTOES, group: 'Ações da escala' },
  { label: 'Apagar escala', value: ESCALA_APAGAR, group: 'Ações da escala' },
  { label: 'Renovar link da escala', value: ESCALA_RENOVAR_LINK, group: 'Ações da escala' },
  { label: 'Compartilhar escala', value: ESCALA_COMPARTILHAR, group: 'Ações da escala' },
  { label: 'Definir parametrização de hora de trabalho', value: DEFINIR_PARAMETRIZACAO_HORA_DE_TRABALHO, group: 'Ações da escala' },

  { label: 'Alterar papel', value: ESCALA_ALTERAR_PAPEL, group: 'Ações do usuário' },
  { label: 'Retirar usuário', value: ESCALA_RETIRAR_USUARIO, group: 'Ações do usuário' },
  { label: 'Ver plantões do usuário', value: ESCALA_VER_PLANTOES_DO_USUARIO, group: 'Ações do usuário' },
  { label: 'Definir parametrização de hora de trabalho', value: DEFINIR_PARAMETRIZACAO_HORA_DE_TRABALHO, group: 'Ações do usuário' },

  { label: 'Novo plantão (plantões do usuário)', value: DETALHES_PLANTAO_NOVO_PLANTAO, group: 'Ações de detalhes do plantão' },
  { label: 'Ver detalhes do plantão (do usuário)', value: DETALHES_PLANTAO_VER, group: 'Ações de detalhes do plantão' },
  { label: 'Apagar (detalhes do plantão)', value: DETALHES_PLANTAO_APAGAR, group: 'Ações de detalhes do plantão' },
  { label: 'Dividir (detalhes do plantão)', value: DETALHES_PLANTAO_DIVIDIR, group: 'Ações de detalhes do plantão' },
  { label: 'Alterar (detalhes do plantão)', value: DETALHES_PLANTAO_ALTERAR, group: 'Ações de detalhes do plantão' },
  { label: 'Personalizar registro', value: DETALHES_PLANTAO_PERSONALIZAR_REGISTRO, group: 'Ações de detalhes do plantão' },
]

//
// DESCONTINUADO
//

/* export const USER_CAPABILITY_OBJECT = USER_CAPABILITIES.reduce((acc, capability) => {
  acc[capability.value] = false
  return acc
}) */

/* export const FULL_PERMISSIONS_USER_CAPABILITY_OBJECT = USER_CAPABILITIES.reduce((acc, capability) => {
  acc[capability.value] = true
  return acc
}) */
